import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchPublicTestStepResult = async ({ tcrid, companyId, otp }) => {
  if (!tcrid || !companyId) throw new Error("Missing required parameters");

  try {
   const response = await axios.get(
  `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getTestCaseDataReportForEmail&companyid=${companyId}&tcrid=${tcrid}&otp=${otp}`,
  { headers: { Authorization: "" } },
);
    return response.data;
  } catch (error) {
    if (error.response?.status === 403) {
  if (!localStorage.getItem("userDetail")) {
    localStorage.setItem("redirectAfterLogin", window.location.href);
  }
  window.location.replace("/LoginPage");
  return null;
}
    throw error;
  }
};

const usePublicTestStepResultQuery = (params) => {
  return useQuery({
    queryKey: ["PublicTestStepResult", params],
    queryFn: () => fetchPublicTestStepResult(params),
    retry: false,
    enabled: Boolean(params.tcrid && params.companyId && params.otp),
    cacheTime: 0,
    refetchIntervalInBackground: false,
    staleTime: 0,
  });
};

export default usePublicTestStepResultQuery;